module.exports = __webpack_public_path__ + "static/media/riskSystemBossTheme.758ffda4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press/riskSystemBossTheme.mp3
// module id = 584
// module chunks = 0